<template>
  <div class="top-header-container">
    <div class="header-wrap"
         v-if="initConfig.userAuthUrl && userInfo.id">
      <tvu-top-header
        :key="userInfo.id"
        :downloadFileToSpeed="initConfig.downloadFile"
        :projectName="$t('serverName')"
        :loopDelayTime="5000"
        tokenService="Mediahub"
        tokenDropdownOptions
        :checkSessionRate="3*60*1000"
        :globalFunList="globalFun"
        :versionServiceNameList="initConfig.dependencyService"
        @callback="topHeaderCallback"
        :languageSwitcher="{ type: 'text' }"
        serviceName="TVU MediaHub">
        <!-- :enableTokenBalanceAlert="true"
        :enableTokenDialog="true" -->
        <!-- 自定义系统级别账号下拉的中间模块 -->
        <template #account-center-module>
          <div
            class="manager collaborate commonLi"
            @click="openAdmin"
            v-if="managerPermission">
            {{$t('Admin')}}
          </div>
          <div v-if="billingInstance && !billingInstance.billingInitMsg"
               class="collaborate commonLi"
               @click="openChargebee">
            <span class="manage-payment">
              <span>{{$t('managePay')}}</span>
              <i class="pending-icon"
                 v-if="postPayPending"></i>
            </span>
            <span
              class="loadingIcon"
              v-loading="chargeLoading">
            </span>
          </div>
          <div v-if="billingInstance && !billingInstance.billingInitMsg"
               class="collaborate commonLi"
               @click="openPlanManage">
            <span>{{$t('planM')}}</span>
          </div>
        </template>

        <!-- 自定义头部中间模块 -->
        <template #top-header-middle>
          <div class="middle-layout">
            <div class="middle-left">
              <div class="header-route">
                <!-- <HeaderRoute/> -->
              </div>
            </div>
            <div class="middle-center">
            </div>
            <div class="middle-right">
              <!-- <div class="source-log">
                <i
                  class="iconfont icon-dashboard"
                  :class="{'is-active': $route.name == 'logPage'}"
                  @click="goRoute()"></i>
              </div> -->
              <div class="top-item">
                <GlobalSetting/>
              </div>
              <div class="top-item">
                <AgentDowloadPopover/>
              </div>
              <div class="whitelist-log"
                   v-if="whiteListEndTime">
                <el-tooltip placement="top">
                  <div slot="content">Your free trial of TVU Media Hub will EXPIRE at <br/><span class="trial-time">{{whiteListEndTimeStr}}</span>
                    <br/><br/>Please contact your TVU sales representative <br/>if you have any questions.</div>
                  <div class="trial-title">Trial Remaining</div>
                </el-tooltip>
                <div class="convert-days">
                  {{convertDays}}
                </div>
              </div>
            </div>
          </div>
        </template>
      </tvu-top-header>
      <!-- <SettingOperate :info="settingInfo"/> -->
      <!-- <div class="jump-login"
           v-if="$route.name == 'welcome'"
           @click="jumpLogin"></div> -->
    </div>
    <div class="skeleton-logo"
         v-else>
      <img
        :src="require('@/assets/img/logo.png')"
        width="32"
        height="32"
        alt="">
      <span class="service-name">TVU MediaHub</span>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import BillingInstance from '@/assets/js/billing'
import { UTCDATE, CONVERTDAYS, DATE } from '@/assets/js/filters'
import GlobalSetting from './globalSetting'
import AgentDowloadPopover from './agentDowloadPopover'
import { TopHeader } from 'tvu-common-ui'
import Cookie from 'js-cookie'
import axios from 'axios'
import { logoutFn } from '@/axios/base'
export default {
  components: {
    GlobalSetting,
    AgentDowloadPopover,
    TvuTopHeader: TopHeader
  },
  data () {
    return {
      delayTime: 0,
      speedMbps: 0,
      drawer: false,
      show: false,
      serviceVersion: [],
      settingInfo: {
        show: true
      },
      chargeLoading: false,
      isChangeRoute: true,
      customerPortal: null,
      postPayPending: false,
      unpaidInvoiceStatus: false,
      whiteListEndTime: 0,
      whiteListEndTimeStr: '',
      convertDays: '',
      convertDaysTimer: null,
      billingInstance: null,
      getPostPayStatusTimer: null
    }
  },
  computed: {
    ...mapState({
      xySwitch: 'xySwitch',
      initConfig: 'initConfig',
      permissionList: 'permissionList',
      userInfo: 'userInfo',
      mediaHubActiveTab: 'mediaHubActiveTab'
    }),
    globalFun () {
      // process.env.NODE_ENV != 'production'
      let globalFunList = ['waffle', 'account', 'helpCenter', 'downloadSpeed', 'networkDelay', 'headerTime']
      if (this.initConfig.useCdn) {
        globalFunList = ['account', 'helpCenter', 'downloadSpeed', 'networkDelay']
      }
      // if (this.initConfig.disableBilling) {
      //   globalFunList = globalFunList.filter(v => v != 'tokenDropdownOptions')
      // }
      if (process.env.NODE_ENV != 'production') { // 本地服务加上networkDelay会404或者跨域
        globalFunList = globalFunList.filter(v => v != 'networkDelay')
      }
      return globalFunList
    },
    managerPermission () {
      return !!this.permissionList.filter(v => v.functionName == 'manage' && v.functionPermission).length
    }
  },
  watch: {
    'initConfig.warnningService': {
      handler: function (val) {
        if (val && !this.globalFun.includes('warningNotice')) {
          this.globalFun.push('warningNotice')
        }
      },
      immediate: true
    },
    'initConfig.userAuthUrl': {
      handler: function (val) {
        if (val && !this.initConfig.disableBilling) {
          this.getBillingInstanceInfo()
        }
      },
      immediate: true
    }
  },
  mounted () {
    setTimeout(() => {
      this.serviceVersion = [{
        serviceName: 'Media Hub',
        frontendVersion: window.localStorage.getItem('mediaHubVersion'),
        backendVersion: '',
        tagName: ''
      }]
    }, 500)
  },
  methods: {
    downloadSpeedTest (fileUrl) {
      const startTime = new Date().getTime()
      axios.get(fileUrl, { responseType: 'blob' }).then(response => {
        const endTime = new Date().getTime()
        const duration = (endTime - startTime) / 1000 // seconds
        const bitsLoaded = response.data.size * 8 // 文件大小以位为单位
        const speedBps = bitsLoaded / duration // 比特每秒
        const speedKbps = speedBps / 1024// 千比特每秒
        const speedMbps = speedKbps / 1024// 兆比特每秒
        this.speedMbps = `${speedMbps.toFixed(2)} Mbps`
        // console.log(27888, response.data.size, new Date(), 'speedMbps:', this.speedMbps)
      }).catch(() => {})
    },
    changeLanguage () {
      const lg = this.$i18n.locale == 'en' ? 'zh-cn' : 'en'
      this.$i18n.locale = lg
      Cookie.set('userLanguage', lg, { domain: '.tvunetworks.com' })
      if (!this.billingInstance) return
      this.billingInstance.toggleLanguage(lg)
    },
    getBillingInstanceInfo () {
      if (!BillingInstance.loaded) {
        return setTimeout(this.getBillingInstanceInfo.bind(this), 500)
      } else {
        this.billingInstance = BillingInstance
        if (!this.billingInstance.billingInitMsg) {
          this.whiteListInfo()
          this.getPostPayStatus()
          this.getPostPayStatusTimer = setInterval(() => {
            this.getPostPayStatus()
          }, 5 * 60 * 1000)
        }
      }
    },
    whiteListInfo () {
      if (!this.billingInstance) {
        return setTimeout(this.whiteListInfo.bind(this), 500)
      }
      this.billingInstance.whiteListInfo({
        customerId: this.userInfo.email,
        product: 'Mediahub'
      }).then(res => {
        if (!res) return
        this.handleWhiteListInfo(res)
      }).catch(() => {})
    },
    handleWhiteListInfo (res) {
      const whiteListInfo = res.data.whiteListInfo
      if (!whiteListInfo) return
      const whiteListEndTime = whiteListInfo.whiteListEndTime
      if (whiteListEndTime === null || whiteListEndTime === '' || whiteListEndTime === '9999999999999') return
      this.whiteListEndTime = whiteListEndTime
      this.whiteListEndTimeStr = UTCDATE(this.whiteListEndTime, 'MM/dd/yyyy hh:mm:ss') + ' UTC'
      this.computedConvertDays()
    },
    computedConvertDays () {
      clearInterval(this.convertDaysTimer)
      if (this.whiteListEndTime < Date.now()) {
        this.convertDays = '00:00:00'
      } else {
        this.convertDays = CONVERTDAYS(Date.now(), this.whiteListEndTime).replace(' days,', 'D')
      }
      this.convertDaysTimer = setInterval(() => {
        if (this.whiteListEndTime < Date.now()) {
          this.convertDays = '00:00:00'
        } else {
          this.convertDays = CONVERTDAYS(Date.now(), this.whiteListEndTime).replace(' days,', 'D')
        }
      }, 1000)
    },
    getPostPayStatus (isvisible) {
      if (!this.billingInstance) {
        return setTimeout(this.getPostPayStatus.bind(this, isvisible), 500)
      }
      this.billingInstance.postPayStatus({
        customerId: this.userInfo.email,
        product: 'Mediahub'
      }).then(res => {
        if (!res) return
        this.handlePostPayStatus(res, isvisible)
      }).catch(() => {})
    },
    async postPayFailed () {
      const text = `
        You account has been suspended due to an unpaid invoice.
        <br>
        Please pay this invoice to resume your usage of TVU Media Hub.
      `
      const value = await this.$confirm(text, 'Suspension due to Unpaid Invoice', {
        customClass: 'billing-confrim',
        cancelButtonText: 'Close',
        confirmButtonText: 'Take me there',
        dangerouslyUseHTMLString: true
      }).catch(() => {})
      if (value == 'confirm') this.openChargebee()
    },
    handlePostPayStatus (res, isvisible) {
      const postPayStatus = res.data.postPayStatus
      if (!postPayStatus) return
      this.postPayStatus = postPayStatus
      this.unpaidInvoiceStatus = postPayStatus.subStatus == 1
      if (postPayStatus.subStatus != 6) return

      // 已经开始pending
      this.postPayPending = postPayStatus.gracePeriodStartTime <= Date.now()
      if (isvisible) return
      // 如果还剩5天
      const endTime = Number(postPayStatus.gracePeriodStartTime) + Number(postPayStatus.gracePeriod)
      if (endTime - Date.now() <= 5 * 24 * 60 * 60 * 1000) {
        this.warningInvoice()
      }
    },
    unPaidInvoice () {
      const date = DATE(this.postPayStatus.gracePeriodStartTime, 'MM/dd/yyyy')
      return this.$confirm(`You currently have an unpaid invoice of <span class="price">$ ${this.postPayStatus.amount / 100}</span> due on <span class="date">${date}</span>.`,
        'Unpaid Invoice', {
          customClass: 'billing-confrim',
          cancelButtonText: 'Close',
          confirmButtonText: 'Pay Now',
          dangerouslyUseHTMLString: true
        }).catch(() => {})
    },
    async openChargebee () {
      if (this.postPayPending) {
        const value = await this.unPaidInvoice()
        if (value != 'confirm') return
      }
      if (BillingInstance && BillingInstance.loaded) {
        if (this.chargeLoading) return
        this.chargeLoading = true
        const params = {
          customerId: this.userInfo.email,
          product: 'Mediahub'
        }
        BillingInstance.instance.handlecustomerPortal(params).then(data => {
          this.confirmOpenWindow(data.customerPortal.url)
          this.chargeLoading = false
        }).catch(() => {
          this.$MHNotify({ title: 'Error', message: this.$t('payError'), type: 'error' })
          this.chargeLoading = false
        })
      }
    },
    async warningInvoice () {
      const text = `
        You currently have an unpaid invoice due in <span class="date">5 days</span>.<br>
        If this invoice is not paid by the due date your account will be suspended.<br>
        Pleas access the Manage Payment section under your User Icon to proceed.
      `
      const value = await this.$confirm(text, 'Warning', {
        customClass: 'billing-confrim',
        cancelButtonText: 'Close',
        confirmButtonText: 'Take me there',
        dangerouslyUseHTMLString: true
      }).catch(() => {})
      if (value == 'confirm') this.openChargebee()
    },
    goGridPage () {
      this.$store.state.xySwitch = !this.$store.state.xySwitch
    },
    confirmOpenWindow (url) {
      this.$confirm(this.$t('openMP'), '', {
        customClass: 'billing-confrim'
      }).then(() => {
        window.open(url)
      }).catch(() => {})
    },
    openPlanManage () {
      if (!this.billingInstance) return
      this.billingInstance.manageBilling()
    },
    settingFn () { },
    jumpLogin () {
      // this.$jumpSSOLogin()
    },
    // goRoute () {
    //   if (this.isChangeRoute) {
    //     if (this.$route.name == 'welcome') {
    //       this.$jumpSSOLogin()
    //       return
    //     }
    //     if (this.$route.name == 'logPage') {
    //       this.$router.push({
    //         name: 'mediaHub'
    //       })
    //       Bus.$emit('changeRoute', 'mediaHub')
    //     } else {
    //       this.$router.push({
    //         name: 'logPage'
    //       })
    //       Bus.$emit('changeRoute', 'logPage')
    //     }
    //     this.isChangeRoute = false
    //     setTimeout(() => {
    //       this.isChangeRoute = true
    //     }, 1000)
    //   }
    // },
    openAdmin () {
      let url
      if (this.initConfig.clientAdminUrl) {
        url = this.initConfig.clientAdminUrl
      } else {
        const protocol = window.location.protocol
        const hostName = window.location.hostname
        url = `${protocol}//${hostName}/admin/#/rootgroup`
      }
      window.open(url, '_blank')
    },
    topHeaderCallback (info) {
      const { type, data = null } = info
      if (type == 'clickLogo') {
        this.$router.push({ name: 'mediaHub' })
      } else if (type == 'signOut') {
        logoutFn().then(res => {
          if (res.errorCode == '0x0') {
            this.$store.dispatch('jumpLoginPage')
          }
        }).catch(() => { })
      } else if (type == 'sessionExpired') {
        this.$store.dispatch('jumpLoginPage')
      } else if (type == 'managePlan') {
        this.openPlanManage()
      } else if (type == 'versionList') {
        this.$store.commit('updateVersionList', data)
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.convertDaysTimer)
    clearInterval(this.getPostPayStatusTimer)
  }
}
</script>
<style lang="less" scoped>
.top-header-container {
  position: relative;
  width: 100%;
  height: 64px;
  line-height: 64px;
  background-color: rgba(0, 0, 0);
  .jump-login {
    position: absolute;
    right: 15px;
    top: 10px;
    height: 40px;
    width: 255px;
    cursor: pointer;
  }
  ::v-deep .warningTips {
    width: 10px;
    height: 10px;
    top: 0px;
    right: -5px;
  }
  .skeleton-logo {
    display: flex;
    align-items: center;
    padding-left: 16px;
    img {
      width: 32px;
      height: 32px;
      margin-top: 2px;
    }
    .service-name {
      position: relative;
      margin-left: 12px;
      font-weight: bold;
      font-size: 16px;
      color: #dbdbdb;
      cursor: pointer;
    }
  }
}
.x-y-monitor {
  font-weight: bold;
  font-size: 14px;
  .el-button--text {
    color: #dbdbdb;
    &.active {
      color: @green;
    }
  }
}
.middle-layout {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}
.middle-left {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.middle-center {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.middle-right {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.top-item {
  margin-left: 20px;
}
.source-log {
  float: right;
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: 20px;
  .icon-dashboard {
    color: #909399;
    font-size: 26px;
    margin-right: 10px;
    cursor: pointer;
    &.is-active {
      color: @green;
    }
  }
}
.header-time, .whitelist-log {
  height: 100%;
  margin-left: 20px;
  .trial-title {
    height: 24px;
    line-height: 30px;
    color: #666666;
  }
  .convert-days {
    font-size: 18px;
    height: 40px;
    line-height: 40px;
    color: #EC5050;
    font-weight: bold;
  }
}
.trial-time {
  color: #EC5050;
}
.unpaid-invoice {
  float: right;
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: 20px;
  font-size: 14px;
  color: #E56464;
  cursor: pointer;
}
.manager {
  line-height: 32px;
  cursor: pointer;
}
.header-route {
  width: fit-content;
  display: inline-block;
}
.collaborate.commonLi {
  font-weight: 500;
  cursor: pointer;
  line-height: 32px;
  .loadingIcon {
    display: inline-block;
    width: 24px;
    height: 24px;
    margin-left: 5px;
    position: relative;
    vertical-align: middle;
    ::v-deep .el-loading-mask {
      background-color: rgba(0, 0, 0, 0);
      .el-loading-spinner {
        height: 24px;
        position: unset;
        margin-top: 0;
      }
      .circular {
        width: 24px;
        height: 24px;
      }
    }
  }
  .manage-payment {
    position: relative;
    .pending-icon {
      position: absolute;
      width: 10px;
      height: 10px;
      background:#FF9A24;
      border-radius: 50%;
      top: 0px;
      right: -12px;
    }
  }
}
</style>
<style lang="less">
.el-message-box.billing-confrim {
  .el-message-box__title {
    font-weight: 700;
    font-size: 16px;
  }
  .el-message-box__content {
    font-size: 14px;
    padding: 10px 35px 20px;
    .price {
      color: #33AB4F;
    }
    .date {
      color: #E56464;
    }
  }
  .el-button {
    background-color: #666666 !important;
    color: #DBDBDB !important;
  }
  .el-button.el-button--primary {
    width: fit-content;
    background-color: #33AB4F !important;
    color: #FFFFFF !important;
  }

}
</style>
